import pagination from './pagination.js'
import paginationBg from './pagination-bg.js'
export default { pagination, paginationBg }
